import React from "react";
import "../App.css";
import { DxCheckbox } from "genesys-react-components";

export function DivisionFilter({
  divisions,
  checkedDivisions,
  setCheckedDivisions,
}) {

  return (
    <div className="division-filter">
      {divisions ? (
        <>
          <p className="division-filter-title">Division Filter</p>
          {divisions.map((division) => {
            return (
              <DxCheckbox
                key={division.id}
                label={division.name}
                value={division.id}
                initialValue={true}
                name={division.name}
                className="clazzy-checkbox m-0"
                onCheckChanged={(checked) => {
                  if (checked) {
                    setCheckedDivisions([...checkedDivisions, division.id]);
                  } else {
                    setCheckedDivisions(
                      checkedDivisions.filter((item) => item !== division.id)
                    );
                  }
                }}
              />
            );
          })}
        </>
      ) : (
        <span className="division-filter-empty">No divisions available</span>
      )}
    </div>
  );
}
